<div class="modal-header">
  <h5 class="modal-title"><ng-content select="[modal-title]"></ng-content></h5>
  @if (!hideClose) {
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal(null)"></button>
  }
</div>
<div class="modal-body py-3">
  <ng-content select="[modal-body]"></ng-content>
</div>
<div class="modal-footer">
  <ng-content select="[modal-footer]"></ng-content>
</div>
